import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_REASON_FOR_BLOCK_DATE, GET_REASON_FOR_BLOCK_DATE_SUCCESS, GET_REASON_FOR_BLOCK_DATE_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* getReasonForBlockDate({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/golf-inventory/block-date/reasons`,
      method: 'GET',
      params: payload?.urlParams,
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_REASON_FOR_BLOCK_DATE_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);

      yield put({
        type: GET_REASON_FOR_BLOCK_DATE_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_REASON_FOR_BLOCK_DATE_ERROR, payload: error });
  }
}

export function* watchGetReasonForBlockDate() {
  yield takeEvery(GET_REASON_FOR_BLOCK_DATE, getReasonForBlockDate);
}

function* getReasonForBlockDateSaga() {
  yield all([fork(watchGetReasonForBlockDate)]);
}

export default getReasonForBlockDateSaga;
